export default "__VITE_ASSET__CY852Aop__"